import { render } from "./PublicationCreate.vue?vue&type=template&id=10d5d030"
import script from "./PublicationCreate.vue?vue&type=script&lang=js"
export * from "./PublicationCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__